import './styles.css'
import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {Modal, Dropdown, Dimmer, Loader} from 'semantic-ui-react';
import { DatePicker, TimePicker, CustomProvider } from "rsuite";
import ru_RU from "rsuite/locales/ru_RU";
import arEG from "rsuite/locales/ar_EG";
import 'rsuite/dist/rsuite.min.css';
import {getRolesAccess} from "../../components/Roles/Roles";
import {ReactComponent as CloseIcon} from "../../icons/filter-close-button.svg";
import FilterComponent from "../../components/FilterComponent/FilterComponent";
import { motion } from "framer-motion";
import {filter} from "lodash";
import {AnimatePresence} from "motion/react";

import {fetchEvents, createEvent, EVENTS_PAGE_COUNT, deleteEvent, changeEvent} from "./actions";
import {getEvents, getEventsFetching, getEventsHasMore, getSingleEvent} from "./reducer";
import {getCounters, getCountersFetching, getCountersHasMore, getSingleCounter} from "../Counterparties/reducer";
import {COUNTERS_PAGE_COUNT, fetchCounters, requestCounters} from "../Counterparties/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import {getAuthToken} from "../../components/UserLogin/reducer";
import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import {getCountries} from "../../components/AddressCard/reducer";
import EditPopup from '../../components/EditPopup';
import {useNotification} from "../../components/Notification";
import CreatePopup from "../../components/CreatePopup";
import DropdownComponent from "../../components/DropdownComponent";
import EventsTableComponent from '../../components/EventsTableComponent';


export default function Events(props) {
    const token = useSelector((state) => getAuthToken(state.userLogin));
    const dispatch = useDispatch();

    if (!token) {
        return (
            <strong style={{margin: '0 0 0 50px'}}>Для получения доступа к списку, пожалуйста, авторизуйтесь</strong>
        )
    }

    const [filterData, setFilterData] = useState({
        countries: [],
        search: '',
        event_action: [],
        event_status: [],
        event_issue: [],
    });

    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isPopupCreateOpen, setIsPopupCreateOpen] = useState(false);
    const [isPopupEditOpen, setIsPopupEditOpen] = useState(false);
    const [usersOptions, setUsersOptions] = useState([]);

    const counters = useSelector((state) => getCounters(state.counters));
    const { openNotification, contextHolder } = useNotification();
    const notificationShown = useRef(false);

    const language = useSelector(getLanguage);
    const languageString = language[0] + language[1];
    const t = (key) => {
        const languageString = language[0] + language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const userData = useSelector((state) => state.userLogin.userData);
    const roleAccess = getRolesAccess(userData.roles);

    const events = useSelector((state) => getEvents(state.events));
    const singleEvent = useSelector((state) => getSingleEvent(state.events));
    const countersFetching = useSelector((state) => getCountersFetching(state.counters));
    const eventsFetching = useSelector((state) => getEventsFetching(state.events));
    const hasMore = useSelector((state) => getEventsHasMore(state.events));
    const loading = (countersFetching || eventsFetching) && !isPopupCreateOpen;

    const navigate = useNavigate();

    useEffect(() => {
        if (!roleAccess.pageEvents || !token) {
            navigate('/');
            return;
        }
        window.scrollTo(0, 0);
        if (token) {
            readEvents(1, filterData);
        }
    }, []);

    useEffect(() => {
        if (!notificationShown.current) {
            const timer = setTimeout(() => {
                openNotification('topRight');
                notificationShown.current = true;
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [openNotification]);

    const handleChangeCountry = (e, {value}) => {
        const newFilterData = {
            ...filterData,
            countries: value,
        };
        setFilterData(newFilterData);
        readEvents(1, newFilterData);
    };

    const handleChangeAction = (e, {value}) => {
        const newFilterData = {
            ...filterData,
            event_action: value,
        };
        setFilterData(newFilterData);
        readEvents(1, newFilterData);
    };

    const handleChangeStatus = (e, {value}) => {
        const newFilterData = {
            ...filterData,
            event_status: value,
        };
        setFilterData(newFilterData);
        readEvents(1, newFilterData);
    };

    const handleChangeIssue = (e, {value}) => {
        const newFilterData = {
            ...filterData,
            event_issue: value,
        };
        setFilterData(newFilterData);
        readEvents(1, newFilterData);
    };

    const handleChangeCounter = (e, {value}) => {
        const newFilterData = {
            ...filterData,
            ca_id: value,
        };
        setFilterData(newFilterData);
        readEvents(1, newFilterData);
    };

    const handleSearchChange = (e, { searchQuery }) => {
        if (searchQuery.length < 3) {
            readCounters(1, searchQuery);
        }
    };

    const handleChangeSearch = (e) => {
        const value = e.target.value;
        const newFilterData = { ...filterData, search: value };
        setFilterData(newFilterData);
        if (value.length > 3) {
            readEvents(1, newFilterData);
        }
        if (value.length === 0) {
            readEvents(1, newFilterData);
        }
    };

    const readEvents = (page, fparams) => {
        dispatch(fetchEvents(token, {
            lang: languageString,
            page: page,
            per_page: EVENTS_PAGE_COUNT,
            order: 'asc',
            orderby: 'on_date',
            ca_id: fparams?.ca_id,
            countries: fparams?.countries,
            search: fparams?.search,
            event_action: fparams?.event_action,
            event_status: fparams?.event_status,
            event_issue: fparams?.event_issue,
        }, t));
    };

    const readCounters = (page, value) => {
        dispatch(fetchCounters(token, {
            page: page ? page : '',
            per_page: COUNTERS_PAGE_COUNT,
            order: 'desc',
            order_by: 'id',
            search: value,
            lang: languageString,
        }, t));
    };

    const loadEvents = () => {
        if (hasMore) {
            const nextPage = Math.round(events.length / EVENTS_PAGE_COUNT) + 1;
            readEvents(nextPage, filterData);
        }
    };

    const handleRowClick = (data) => {
        dispatch(fetchEvents(token, { id: data.id, lang: languageString }, t)).then((res) => {
            dispatch(fetchCounters(token, { id: res.respondent_ca.ca_id, lang: languageString }, t))
                .then((counterRes) => {
                    const updatedCounter = counterRes;
                    setUsersOptions(
                        updatedCounter.users?.map((user) => ({
                            text: languageString === 'ru' ? user.full_name : user.full_name_en,
                            value: String(user.id),
                        })) || []
                    );
                    setIsPopupEditOpen(true);
                })
                .catch((error) => {
                    console.error('Ошибка при загрузке counters:', error);
                });
        });
    };

    const handleDoneEvent = (value, id, addInfo) => {
        dispatch(changeEvent(token, id, {
            add_info: addInfo,
            event_status: 'done',
            issue: value,
            lang: languageString,
        }, t)).then(() => {
            readEvents(1, filterData);
        }).catch((error) => {
            console.error("Ошибка при обновлении события:", error);
        });
    };

    const handleCancelEvent = (id, addInfo) => {
        dispatch(changeEvent(token, id, {
            add_info: addInfo,
            event_status: 'canceled',
            issue: 'none',
            lang: languageString,
        }, t)).then(() => {
            readEvents(1, filterData);
        }).catch((error) => {
            console.error("Ошибка при обновлении события:", error);
        });
    };

    const handleDelayedEvent = (id, addInfo) => {
        dispatch(changeEvent(token, id, {
            add_info: addInfo,
            event_status: 'delayed',
            issue: 'none',
            lang: languageString,
        }, t)).then(() => {
            readEvents(1, filterData);
        }).catch((error) => {
            console.error("Ошибка при обновлении события:", error);
        });
    };

    const handleDeleteEvent = (id) => {
        dispatch(deleteEvent(token, id, {lang: languageString}, t))
            .then(() => {
                setIsPopupEditOpen(false);
                readEvents(1, filterData);
            });
    };

    const handleEditEvent = (id, fields) => {
        dispatch(changeEvent(token, id, {...fields, lang: languageString}, t));
        readEvents(1, filterData);
    };

    const eventStatusesOptions = singleEvent && singleEvent?.settings?.crm_event_statuses
        ? Object.entries(singleEvent.settings.crm_event_statuses).map(([value, texts]) => ({
            text: texts[languageString] || value,
            value,
        }))
        : [];

    const typeMeetingOptions = [
        {
            text: languageString === 'ru' ? "Телефонный звонок" : "Phone Call",
            value: 'phone'
        },
        {
            text: languageString === 'ru' ? "Электронное письмо" : "Send Mail",
            value: 'mail'
        },
        {
            text: languageString === 'ru' ? "Встреча онлайн" : "Meeting Online",
            value: 'meet online'
        },
        {
            text: languageString === 'ru' ? "Встреча оффлайн" : "Meeting Offline",
            value: 'meet offline'
        },
        {
            text: languageString === 'ru' ? "Входящее обращение" : "Incoming Appeal",
            value: 'appeal'
        },
    ];

    const issuesOptions = singleEvent && singleEvent?.settings?.crm_event_issues
        ? Object.entries(singleEvent.settings.crm_event_issues).map(([value, texts]) => ({
            label: texts[languageString] || value,
            value,
        }))
        : [];

    const countries = useSelector((state) => getCountries(state.address));
    const arrayCountries = countries && countries.countries ? Object.values(countries.countries).map(country => ({
        'key': country.iso.toLowerCase(),
        'value': country.iso.toLowerCase(),
        'flag': country.iso.toLowerCase(),
        'text': languageString === "en" ? country.country_en : country.country_ru,
        'states': country.states
    })) : [];

    const counterOptions = counters.map(counter => ({
        value: counter.id,
        text: languageString === 'ru' ? counter.name : counter.name_en,
    }));

    return (
        <div className='events'>
            <div className='events-title'>{t('events')}</div>
            <div className='events-header-container'>
                <EditPopup
                    isPopupOpen={isPopupEditOpen}
                    setIsPopupOpen={setIsPopupEditOpen}
                    isLoading={loading}
                    event={singleEvent}
                    deleteFunction={handleDeleteEvent}
                    editFunction={handleEditEvent}
                    options={{
                        eventStatusesOptions: eventStatusesOptions,
                        typeMeetingOptions: typeMeetingOptions,
                        usersOptions: usersOptions,
                        issuesOptions: issuesOptions,
                    }}
                />
                <CreatePopup
                    isPopupOpen={isPopupCreateOpen}
                    setIsPopupOpen={setIsPopupCreateOpen}
                    options={{
                        usersOptions,
                        typeMeetingOptions,
                    }}
                />
                <FilterComponent open={isFilterOpen} onChange={() => setIsFilterOpen(!isFilterOpen)} />
            </div>
            <AnimatePresence initial={false}>
                {isFilterOpen ? <motion.div
                    className='counter-filter-content'
                    initial={{maxHeight: 0, opacity: 0}}
                    animate={{maxHeight: 1000, opacity: 1, transition: {duration: 1}}}
                    exit={{maxHeight: 0, opacity: 0, transition: {duration: 0.4}}}
                >
                    <div className='counter-flex '>
                        <div className='counter-column'>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('eventType')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    scrolling
                                    selection
                                    multiple
                                    options={typeMeetingOptions}
                                    className='cform-drop filter-drop'
                                    value={filterData.event_action}
                                    onChange={handleChangeAction}
                                />
                            </div>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('counterparty')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    className='events-dropdown filter-drop'
                                    options={[{
                                        value: '',
                                        text: languageString === 'ru' ? 'Cбросить' : 'Reset'
                                    }, ...counterOptions]}
                                    value={filterData.ca_id}
                                    onChange={handleChangeCounter}
                                    onSearchChange={handleSearchChange}
                                    selection
                                    noResultsMessage="Ничего не найдено"
                                />
                            </div>
                        </div>
                        <div className='counter-column'>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('eventStatus')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    scrolling
                                    selection
                                    multiple
                                    options={eventStatusesOptions}
                                    className='cform-drop filter-drop'
                                    value={filterData.event_status}
                                    onChange={handleChangeStatus}
                                />
                            </div>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('eventOutcome')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    selection
                                    multiple
                                    options={issuesOptions}
                                    className='cform-drop filter-drop'
                                    value={filterData.event_issue}
                                    onChange={handleChangeIssue}
                                />
                            </div>
                        </div>
                    </div>
                </motion.div> : null}
            </AnimatePresence>
            <div className='events-content'>
                <EventsTableComponent
                    events={events}
                    languageString={languageString}
                    handleDoneEvent={handleDoneEvent}
                    handleDeleteEvent={handleDeleteEvent}
                    handleRowClick={handleRowClick}
                    loadEvents={loadEvents}
                    hasMoreEvents={hasMore}
                    t={t}
                    isLoading={eventsFetching}
                />
            </div>
            <Dimmer
                active={loading}
                inverted
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}
            >
                <Loader size="large">{t('loadingEvents')}</Loader>
            </Dimmer>
            {/*<div>{contextHolder}</div>*/}
        </div>
    );
}